import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

export const CustomVolume2 = (props: {}): JSX.Element => (
    <SvgIcon {...props}>
        <g>
            <path d={'M3.6167 9.4354H5.28337V17.7687H3.6167V9.4354Z'} />
            <path d={'M7.78337 2.76874H9.45003V17.7687H7.78337V2.76874Z'} />
            <path d={'M11.95 11.9354H13.6167V17.7687H11.95V11.9354Z'} />
            <path d={'M16.1167 6.9354H17.7834V17.7687H16.1167V6.9354Z'} />
        </g>
    </SvgIcon>
);
